import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

const ViewFeesModal = ({
  businessId,
  applicationId,
  getFeesList,
  feesList,
  isLoading,
  deleteApplicationFees,
  getSingleNewBusinesses,
  feesInfo,
}) => {
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');

  useEffect(() => {
    getFeesList(businessId, applicationId);
  }, []);

  const quarter = (period) => {
    if (period === 1) return '1 QTR';
    if (period === 2) return '2 QTR';
    if (period === 3) return '3 QTR';
    if (period === 4) return '4 QTR';
    return '';
  };

  const handleDeleteApplicationFees = () => {
    ConfirmAlert(
      'Are you sure you want to delete this business application fees?',
      () => {
        deleteApplicationFees(businessId, applicationId, () => {
          setModal({ isOpen: false });
          getSingleNewBusinesses(businessId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleCloseModal = () => setModal({ isOpen: false });

  return (
    <Modal.Body>
      <div>
        <div className="row">
          <div className="col-12">
            {Acl(permissions, ['DELETE BUSINESS PERMIT APPLICATION FEES']) &&
            _.get(feesInfo, 'attributes.is_imported') &&
            !_.isEmpty(feesList) ? (
              <div className="mx-0 my-2 text-right">
                <button
                  type="button"
                  className="btn-blank px-0"
                  onClick={handleDeleteApplicationFees}
                >
                  <i className="far fa-trash-alt icon-delete py-2" />
                </button>
              </div>
            ) : null}
            <div className="table-responsive">
              {isLoading ? (
                <div className="loading">
                  <div className="spinner text-center">
                    <span className="fas fa-1x fa-spin fa-spinner" />
                  </div>
                </div>
              ) : (
                <table className="table table-bordered table-sm table-hover">
                  <thead className="table-header">
                    <tr>
                      <td>Code</td>
                      <td>Description</td>
                      <td>Year</td>
                      <td>Amount</td>
                      <td>Discount</td>
                      <td>Interest</td>
                      <td>Surcharge</td>
                      <td>Total Amount</td>
                      <td>Period</td>
                    </tr>
                  </thead>
                  <tbody className="table-details">
                    {feesList.map((item) => {
                      return (
                        <tr key={`business_logs${item.id}`}>
                          <td className="text-left">
                            {_.get(item, 'attributes.code') || '-'}
                          </td>
                          <td className="text-left">
                            {_.get(item, 'attributes.description') || '-'}
                          </td>
                          <td className="text-center">
                            {_.get(item, 'attributes.year') || '-'}
                          </td>
                          <td className="text-center">
                            {_.get(item, 'attributes.amount_human') || '-'}
                          </td>
                          <td className="text-center">
                            {_.get(item, 'attributes.disount_human') || '-'}
                          </td>
                          <td className="text-center">
                            {_.get(item, 'attributes.penalty_human') || '-'}
                          </td>
                          <td className="text-center">
                            {_.get(item, 'attributes.surcharge_human') || '-'}
                          </td>
                          <td className="text-center">
                            {_.get(item, 'attributes.total_human') || '-'}
                          </td>
                          <td className="text-center">
                            {_.get(item, 'attributes.qtr_from') || '-'}-
                            {quarter(_.get(item, 'attributes.qtr_to')) || '-'}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>

            <div className="d-flex justify-items-center">
              <button
                disabled={isLoading}
                type="button"
                onClick={handleCloseModal}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary mx-auto"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal.Body>
  );
};

ViewFeesModal.propTypes = {
  businessId: PropTypes.string.isRequired,
  applicationId: PropTypes.string.isRequired,
  getFeesList: PropTypes.instanceOf(Function).isRequired,
  feesList: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  deleteApplicationFees: PropTypes.instanceOf(Function).isRequired,
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  feesInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  feesList: _.get(api, `${c.GET_FEES_LIST}.list`) || [],
  isLoading: api.loading.indexOf(c.GET_FEES_LIST) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewFeesModal);
